<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-table
        :columns="table.columns"
        :rowKey="record => record.id"
        :dataSource="table.data"
        :pagination="pagination"
        :loading="table.loading"
        @change="handleTableChange"
      ></a-table>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { getHistoryBidding } from '@/api/friendBusiness'
export default {
  name: 'HistoryBidding',
  mounted () {},
  computed: {},
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 1200,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      visible: false,
      defaultModel: {},
      model: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      table: {
        data: [],
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            width: '15%',
            align: 'center'
          },
          {
            title: '市场名称',
            dataIndex: 'marketName',
            width: '40%'
          },
          {
            title: '开标日期',
            dataIndex: 'openingTime',
            width: '15%'
          },
          {
            title: '投标价（元）',
            dataIndex: 'tenderPrice',
            width: '15%'
          },
          {
            title: '是否中标',
            dataIndex: 'isBidding',
            customRender: (text) => {
              if (text === 1) {
                return '中标'
              } else if (text === 0) {
                return '未中标'
              }
            },
            width: '15%'
          }
        ],
        loading: false
      }
    }
  },
  methods: {
    initTableData () {
      const params = {
        friendBusinessId: this.model.id,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      this.table.loading = true
      getHistoryBidding(params).then(res => {
        this.table.loading = false
        if (res.status === 0) {
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        }
      })
    },
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = '友商名称：' + title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        this.initTableData()
      }
    },
    formClear () {
      this.table.data = []
      this.table.loading = false
      this.pagination = {
        current: 1,
        pageSize: 10,
        total: 0
      }
    },
    cancel () {
      this.formClear()
      this.open(false)
    },

    handleTableChange (pagination) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.initTableData()
    }

  }
}
</script>

<style scoped lang="less">

</style>
